var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"popup"},[_c('Container',{attrs:{"config":{ showHeader: true, showCloseButton: true, title: _vm.title }},on:{"close":_vm.close}},[(_vm.errorMsg)?_c('h3',{staticClass:"warning",domProps:{"innerHTML":_vm._s(_vm.errorMsg)}}):_vm._e(),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }